import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Container, H1, Loading, Button, Label, Grid, GridItem } from "@utdanningsdirektoratet/lisa";
import TEXT from "./TEXT";
import { EksempelOppgavePassordApiClient } from "../../elev/generated/clients/EksempelOppgavePassordApiClient";
import { useCallableRequest } from "../common/hooks/useCallableRequest";
import styled from "styled-components";
import { P } from "../common/components/p";
import { useFormInputField } from "@utdanningsdirektoratet/lisa-forms";
import { getElevAppSpecificContext } from "common/commonContext";
import { EksempeloppgaveContext } from "@generated/types/contextModels";

const LoadingContainer = styled.div`
	display: flex;
	align-items: center;
	text-align: center;
`;

export const EksempeloppgaverApp = () => {
	const [isRedirecting, setIsRedirecting] = useState<boolean>(false);

	const { handleSubmit, setError, control } = useForm<{ passord: string }>({
		mode: "onChange",
		reValidateMode: "onSubmit",
		defaultValues: { passord: "" }
	});

	const { input, errorMessage } = useFormInputField({
		id: "passord-input",
		control,
		name: "passord",
		rules: { required: { value: true, message: TEXT.passordRequired } },
		label: "passord"
	});

	const { deliveryId } = getElevAppSpecificContext<EksempeloppgaveContext>();
	const verifyPasswordRequest = useCallableRequest({
		requestFunction: (password: string) =>
			EksempelOppgavePassordApiClient.autoriserEksempeloppgavePassord(password, deliveryId),
		onSuccess: (redirectUrl: string) => {
			setIsRedirecting(true);
			window.location.href = redirectUrl;
		},
		onError: (_, error) => {
			if (error.statusCode === 401) {
				setError("passord", { message: TEXT.feilPassord });
			}
		},
		selfHandleErrors: [401]
	});

	return (
		<>
			<H1 textStyle="display">{TEXT.title}</H1>
			<Container padding={40} backgroundColor={"hvit"} maxWidth="640px">
				<P>{TEXT.beskrivelse}</P>
				{!isRedirecting ? (
					<form
						onSubmit={handleSubmit(e => {
							verifyPasswordRequest.execute(e.passord);
						})}
					>
						<Label textStyle="headline" className="mt-12" htmlFor="passord-input">
							{TEXT.passord}
						</Label>
						<Grid>
							<GridItem columns={{ xsmall: 12, small: 5 }}>
								{input}
								{errorMessage}
							</GridItem>
							<GridItem columns={{ xsmall: 12, small: 7 }}>
								<Button pending={verifyPasswordRequest.pending}>{TEXT.submitKnapp}</Button>
							</GridItem>
						</Grid>
					</form>
				) : (
					<LoadingContainer>
						<P className="mt-12">{TEXT.videresenderTilOppgaven}</P>
						<Loading size="large" pending={true} />
					</LoadingContainer>
				)}
			</Container>
		</>
	);
};
